import {
  json as baseJson,
  info as baseInfo,
} from '../../Base/Special-Offer_oneColumn'
import themeBase from './_themeBase'
import INDEX from './_index'

const info = JSON.parse(JSON.stringify(baseInfo))
const json = JSON.parse(JSON.stringify(baseJson))
const templateID = info.templateID + INDEX

info.templateID = templateID
info.priority = 10
json.templateID = templateID

json.settings = {
  ...json.settings,
  closeButtonColor: '#FFDF00',
}

// Apply theme-specific styling overrides
json.styling = {
  ...json.styling,
  backgroundColor: '#0c1a29',
  backgroundImage: '',
}

json.theme = themeBase.theme

// Modify content items as needed
json.steps[0].contentItems = json.steps[0].contentItems.map((item, index) => {
  switch (index) {
    case 0: // image Headline
      item.content.url = 'https://assets.onvocado.com/templates/ny-5.webp'
      break
    case 4: // Second Headline
      item.content.text = 'FREE GIFT WITH EVERY ORDER!'
      break
    case 5: // First Text
      item.content.text = 'Receive a complimentary gift automatically with every order!'
      break
  }
  return item
})

export { json, info };